import { render, staticRenderFns } from "./ShiftsOverview.vue?vue&type=template&id=2a73de1f"
import script from "./ShiftsOverview.vue?vue&type=script&lang=js"
export * from "./ShiftsOverview.vue?vue&type=script&lang=js"
import style0 from "./ShiftsOverview.vue?vue&type=style&index=0&id=2a73de1f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports